import type { IEntity } from '../entities/entitiesUtils'
import { entitiesUtils } from '../entities/entitiesUtils-sidecar'
import { assert } from '../lib/assert-sidecar'
import { l } from '../lib/imports'
import { common } from '../main/common-sidecar'

import type { IFontData2 } from './fontData2'
import { fontData2 } from './fontData2-sidecar'
import { spritesUtil } from '../sprites/spritesUtil-sidecar'
import type { PImage, PContainer } from '../engine/aliases'

export interface IStevieText2 extends IEntity {
  images: PImage[]
  visibleImages: number
  text: string
  font: IFontData2
  x: number
  y: number
  wrapWidth: number
  layer: PContainer
  tint: number
  alpha: number
  monospace: boolean
  isVisible: boolean
  scale: number
  isAlignRight: boolean
}

const objs: IStevieText2[] = []

export function findById(id: number) {
  return entitiesUtils.findById(id, objs)
}

export function create(
  font: IFontData2,
  x: number = 0,
  y: number = 0,
  layer: PContainer, // | null = null,
): IStevieText2 {
  let id = common.createId()

  // if (!layer) {
  //   asser
  //   // layer = underLayers.getLayers().ui
  // }

  let obj: IStevieText2 = {
    eType: 'stevie-text',
    id,
    idLoaded: 0,
    images: [],
    visibleImages: 0,
    isDead: false,
    text: '',
    font,
    x,
    y,
    layer,
    tint: 0xffffff,
    alpha: 1,
    monospace: false,
    isVisible: true,
    scale: 1,
    wrapWidth: 500,
    isAlignRight: false,
  }
  objs.push(obj)
  return obj
}

export function moveTo(obj: IStevieText2, x: number, y: number) {
  let dx = x - obj.x
  let dy = y - obj.y
  obj.x = x
  obj.y = y
  l.forEach(obj.images, (c) => {
    c.x += dx
    c.y += dy
  })
}

export function setAlignRight(obj: IStevieText2, wrapWidth: number) {
  obj.isAlignRight = true
  obj.wrapWidth = wrapWidth
  setText(obj, obj.text, true)
}

export function setText(
  obj: IStevieText2,
  text: string,
  force: boolean = false,
) {
  if (text === obj.text && !force) {
    return
  }
  obj.text = text

  let x = obj.x
  let y = obj.y

  let maxX = obj.x + obj.wrapWidth
  let isWrapped = true
  let wrapIdx = 0
  let wrapX = x
  let wordWidth = 0

  let font = obj.font
  // Make existing images invisible
  for (let i = 0; i < obj.images.length; i++) {
    let c = obj.images[i]
    c.visible = false
  }

  let fMonospace = fontData2.getLetter(font, '0')
  assert.notNil(fMonospace)

  const onNewline = () => {
    if (obj.isAlignRight) {
      let alignX = maxX - x
      for (let i = wrapIdx; i < obj.images.length; i++) {
        let image = obj.images[i]
        image.x += alignX
      }
    }
  }

  let imageIdx = 0
  let lineHeight = font.charHeight * 1.0 * obj.scale
  for (let i = 0; i < text.length; i++) {
    // console.log('merp', i, text)
    let letter = text[i]
    if (letter === '\n') {
      isWrapped = true
      onNewline()
      wrapIdx = imageIdx
      wordWidth = 0
      x = obj.x
      y += lineHeight
    } else if (letter === ' ') {
      isWrapped = false
      wrapIdx = imageIdx
      wordWidth = 0

      if (obj.monospace) {
        x += fMonospace.w * obj.scale
      } else {
        x += font.spaceWidth * obj.scale
      }
      wrapX = x
    } else {
      let f = fontData2.getLetter(font, letter)
      if (f) {
        let tx = x
        if (obj.monospace) {
          tx += (fMonospace.w - f.w) * obj.scale
        }

        // if (f.leading) {
        //   x +=
        // }

        if (imageIdx >= obj.images.length) {
          let newImage = spritesUtil.createImage(obj.layer, f.frame)
          newImage.tint = obj.tint
          newImage.setAlpha(obj.alpha)
          // newImage.alpha = obj.alpha
          obj.images.push(newImage)
        } else {
          spritesUtil.setPackedFrame(obj.images[imageIdx], f.frame)
        }
        let image = obj.images[imageIdx]
        image.x = tx + f.leading * obj.scale
        image.y = y + f.oy * obj.scale
        image.visible = obj.isVisible
        image.scale = obj.scale

        if (obj.monospace) {
          f = fMonospace
        }

        let letterW = f.w * obj.scale + font.charSpacing * obj.scale
        wordWidth += letterW
        x += letterW

        imageIdx++
      } else {
        let letterW = font.spaceWidth * obj.scale
        wordWidth += letterW
        x += letterW
        console.warn('missing font letter', letter)
      }
      if (x > maxX) {
        if (!isWrapped) {
          onNewline()

          let left = wrapX - obj.x

          x = obj.x + wordWidth
          y += lineHeight

          for (
            let iWrap = wrapIdx;
            iWrap < obj.images.length && iWrap <= imageIdx;
            iWrap++
          ) {
            let imageWrap = obj.images[iWrap]
            imageWrap.y += lineHeight
            imageWrap.x -= left
            // x = imageWrap.x
          }

          isWrapped = true
        }
      }
    }
  }
  obj.visibleImages = imageIdx

  onNewline()
}

export function kill(obj: IStevieText2 | null) {
  if (!obj) {
    return
  }
  obj.isDead = true
}

export function killBulk(objs: IStevieText2[]) {
  l.forEach(objs, (c) => {
    kill(c)
  })
  return []
}

export function updateAll() {
  // objs.forEach((c) => {
  //   // update(c)
  // })
  entitiesUtils.removeDead(objs, (c) => {
    c.images.forEach((d) => {
      d.destroy()
    })
  })
}

// function textCreateImageFromFrame(
//   layer: Layer,
//   frame: Phaser.Textures.Frame,
//   x: number,
//   y: number,
//   scale: number = 1,
// ) {
//   let phaserScene = common.getPhaserScene()
//   let image = phaserScene.add.image(0, 0, '')
//   layer.add(image)
//   image.width = frame.width
//   image.height = frame.height
//   image.frame = frame
//   image.originX = 0.5
//   image.originY = 0.5
//   image.x = x
//   image.y = y
//   if (scale) {
//     image.setScale(scale)
//   }
//   image.setDisplayOrigin(0, 0)

//   return image
// }

export function setVisible(obj: IStevieText2, visible: boolean) {
  obj.isVisible = visible
  for (let i = 0; i < obj.images.length; i++) {
    let c = obj.images[i]
    c.visible = visible && i < obj.visibleImages
  }
}

export function setScale(obj: IStevieText2, newScale: number) {
  if (obj.scale !== newScale) {
    obj.scale = newScale
    setText(obj, obj.text, true)
  }
}

export function setTint(obj: IStevieText2, tint: number) {
  obj.tint = tint
  for (let i = 0; i < obj.images.length; i++) {
    let c = obj.images[i]
    c.tint = tint
  }
}

export function setAlpha(obj: IStevieText2, a: number) {
  obj.alpha = a
  for (let i = 0; i < obj.images.length; i++) {
    let c = obj.images[i]
    c.setAlpha(a)
    // c.alpha = a
  }
}

export function setWrapWidth(obj: IStevieText2, w: number) {
  if (w !== obj.wrapWidth) {
    obj.wrapWidth = w
    setText(obj, obj.text, true)
  }
}

export function setBulkVisible(objs: IStevieText2[], isVisible: boolean) {
  l.forEach(objs, (c) => setVisible(c, isVisible))
}

export function setMonospace(obj: IStevieText2, monospace: boolean) {
  obj.monospace = monospace
  setText(obj, obj.text, true)
}
